<template>
  <div class="form-title">
    <h1
      v-if="size === 'Titel'"
    >
      {{ title }}
    </h1>
    <h2
      v-if="size === 'Sub-titel'"
    >
      {{ title }}
    </h2>
    <h3
      v-if="size === 'Sub-sub-titel'"
    >
      {{ title }}
    </h3>
  </div>
</template>

<script>
export default {
  name: 'FormTitle',

  schema: [
    {
      name: 'title',
      default: 'Titel',
      type: 'FormText',
      label: 'Titel',
    },
    {
      name: 'size',
      options: [
        'Titel', 'Sub-titel', 'Sub-sub-titel',
      ],
      type: 'FormSelect',
      label: 'Gewenste hoofdstuk grote',
      required: true,
    },
  ],

  props: {
    title: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'Titel',
    },
  },
};
</script>

<style lang="scss">
.form-title {
  flex-grow: 1;

  h1, h2, h3 {
    line-height: 30px;
    margin: 0 0 0 40px;
  }
}
</style>
